import _ from "lodash";

export const getParams = (val) => {
  const path =
    window.location.search || `?${_.split(window.location.hash, "?")[1]}`;
  const params = new URLSearchParams(path);
  return params.has(val) ? params.get(val) : undefined;
};
